import moment from "moment";
import _i18n from "../reducers/i18n";
import store from "../store";

let i18n = _i18n();
const getActiveLanguage = () =>
  store.getState()?.uiLanguage || store.getState()?.language || "de";
const getActiveI18n = () => _i18n(getActiveLanguage());

/* Notification Types */
const notificationTypes = [
  { code: 0, value: "Stillstand" },
  { code: 1, value: "Auffälligkeit" },
  { code: 2, value: "Notiz" },
  { code: 3, value: "Aufgabe" },
  { code: 4, value: "Interne Mitteilung" },
  { code: 5, value: "Herstellermitteilung" },
  { code: 6, value: "Geplant Wartung" },
  { code: 7, value: "Reaktive Wartung" },
  { code: 8, value: "Instandsetzung" },
  { code: 9, value: "Verbesserung" },
  { code: 10, value: "Ungeplanter Stillstand (Verschleiß)" },
  { code: 11, value: "Ungeplanter Stillstand (Bedienungsfehler)" },
  { code: 12, value: "Störung (ohne Stillstand)" },
];

const getNotificationTypee = (type, lang, count) => {

  if (lang === undefined) {
    lang = "de";
  }


  type = Number(type);

  if (lang === "en") {
    if (type === 0) return "Downtime";
    if (type === 1) return "Downtime";
    if (type === 2) return "Downtime";
    if (type === 3) return "Malfunction";
    if (type === 4) return "Anomaly";
    if (type === 5) return "Note";
    if (type === 6) return "Planned Maintenance";
    if (type === 7) return "Reactive Maintenance";
    if (type === 8) return "Repair";
    if (type === 9) return "Improvement";
    // else return "the Notification";
  } else {
    if (type === 0)
      return count > 1
        ? "Ungeplanter Stillstand (Technischer Defekt)"
        : "Ungeplanter Stillstand (Technischer Defekt)";
    if (type === 1) return count > 1 ? "Auffälligkeiten" : "Auffälligkeit";
    if (type === 2) return count > 1 ? "Notizen" : "Notiz";
    if (type === 3) return count > 1 ? "Aufgaben" : "Aufgabe";
    if (type === 4)
      return count > 1 ? "Interne Mitteilungen" : "Interne Mitteilung";
    if (type === 5)
      return count > 1 ? "Herstellermitteilungen" : "Herstellermitteilung";
    if (type === 6)
      return count > 1 ? "Geplante Wartungen" : "Geplante Wartung";
    if (type === 7)
      return count > 1 ? "Reaktive Wartungen" : "Reaktive Wartung";
    if (type === 8) return count > 1 ? "Instandsetzungen" : "Instandsetzung";
    if (type === 9) return count > 1 ? "Verbesserungen" : "Verbesserung";
    if (type === 10)
      return count > 1
        ? "Ungeplante Stillstände (Verschleiß)"
        : "Ungeplanter Stillstand (Verschleiß)";
    if (type === 11)
      return count > 1
        ? "Ungeplante Stillstände (Bedienungsfehler)"
        : "Ungeplanter Stillstand (Bedienungsfehler)";
    if (type === 12)
      return count > 1
        ? "Störungen (ohne Stillstand)"
        : "Störung (ohne Stillstand)";
    // else return " der Meldung"
  }
};

function getNotificationTooltipAndColor(type) {
  const lang = getActiveLanguage();
  const isEnglish = lang === "en";

  switch (type) {
    case 0:
      return {
        tooltip: isEnglish
          ? "Unplanned downtime (technical fault)"
          : "Ungeplanter Stillstand (Technischer Defekt)",
        color: "#FF3D00",
      };
    case 1:
      return {
        tooltip: isEnglish ? "Anomaly" : "Auffälligkeit",
        color: "#FFB300",
      };
    case 2:
      return {
        tooltip: isEnglish ? "Note" : "Notiz",
        color: "#AEAEAE",
      };
    case 3:
      return {
        tooltip: isEnglish ? "Task" : "Aufgabe",
        color: "#AEAEAE",
      };
    case 4:
      return {
        tooltip: isEnglish
          ? "Internal message (not used)"
          : "Interne Mitteilung (not used)",
        color: "#B0BEC5",
      };
    case 5:
      return {
        tooltip: isEnglish
          ? "Manufacturer message (not used)"
          : "Herstellermitteilung (not used)",
        color: "#B0BEC5",
      };
    case 6:
      return {
        tooltip: isEnglish ? "Planned maintenance" : "Geplant Wartung",
        color: "#039BE5",
      };
    case 7:
      return {
        tooltip: isEnglish ? "Reactive maintenance" : "Reaktive Wartung",
        color: "#039BE5",
      };
    case 8:
      return {
        tooltip: isEnglish ? "Repair" : "Instandsetzung",
        color: "#8E24AA",
      };
    case 9:
      return {
        tooltip: isEnglish ? "Improvement" : "Verbesserung",
        color: "#6FA03B",
      };
    case 10:
      return {
        tooltip: isEnglish
          ? "Unplanned downtime (wear)"
          : "Ungeplanter Stillstand (Verschleiß)",
        color: "#FF3D00",
      };
    case 11:
      return {
        tooltip: isEnglish
          ? "Unplanned downtime (operating error)"
          : "Ungeplanter Stillstand (Bedienungsfehler)",
        color: "#FF3D00",
      };
    case 12:
      return {
        tooltip: isEnglish ? "Fault (without downtime)" : "Störung (ohne Stillstand)",
        color: "#ED6F26",
      };
    default:
      return {
        tooltip: isEnglish ? "Unknown type" : "Unbekannter Typ",
        color: "#000000",
      };
  }
}
function NotificationType(type, count) {
  const lang = getActiveLanguage();
  let notificationTypeString = "";
  notificationTypes.map((notificationType) => {
    if (notificationType.code === Number(type)) {
      notificationTypeString = getNotificationTypee(
        notificationType.code,
        lang,
        count
      );
    }
  });
  return notificationTypeString;
}

function NotificationTypeUpdated(type, notification) {
  // geplant wartund needs to have label of hascategory .
  const lang = getActiveLanguage();
  let notificationTypeString = "";
  notificationTypes.map((notificationType) => {
    if (notificationType.code === Number(type)) {
      if (Number(type) === 6) {
        notificationTypeString = (notification?.hasmaintenancetask && notification?.hasmaintenancetask[0]?.maintenancetask?.hascategory )
          ? notification?.hasmaintenancetask[0]?.maintenancetask?.hascategory[0]
              ?.maintenancecategory?.name
          : "";
      } else {
        notificationTypeString = getNotificationTypee(notification.type, lang);
      }
    }
  });
  return notificationTypeString;
}

function GetNotificationTypeCode(type) {
  let notificationTypeCodeString = "";
  notificationTypes.map((notificationType) => {
    if (notificationType.code === String(type)) {
      notificationTypeCodeString = notificationType.code;
    }
  });
  return notificationTypeCodeString;
}

/* Notification States */
function StatusType(type) {
  const locale = getActiveI18n();
  const notificationStates = [
    { code: 0, value: "open", label: locale.state_open },
    { code: 1, value: "indiscussion", label: locale.state_in_discussion },
    { code: 2, value: "closed", label: locale.state_closed },
  ];

  let str = "";
  notificationStates.map((statusType) => {
    if (statusType.code === Number(type)) {
      return (str = statusType.label);
    }
  });
  return str;
}

// const maintenance_templates = [
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory11",
//     title: "Titel der Vorlage 1",
//     category: {
//       name: "Inspektion (intern)",
//       colorcode: "#00887a",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
//     },
//     creationdate: 1673644800000,
//     repetition: "1w",
//     reminder: "1w",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory33",
//     title: "Titel der Vorlage 2",
//     category: {
//       name: "Routinewartung (intern)",
//       colorcode: "#d81a60",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
//     },
//     creationdate: 1673731200000,
//     repetition: "1m",
//     reminder: "2w",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory44",
//     title: "Titel der Vorlage 3",
//     category: {
//       name: "Herstellerwartung",
//       colorcode: "#3a48ab",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory4",
//     },
//     creationdate: 1673817600000,
//     repetition: "6m",
//     reminder: "1m",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory55",
//     title: "Titel der Vorlage 4",
//     category: {
//       name: "Pflichtinspektion",
//       colorcode: "#728217",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory1",
//     },
//     creationdate: 1673904000000,
//     repetition: "18m",
//     reminder: "2w",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory66",
//     title: "Titel der Vorlage 5",
//     category: {
//       name: "Inspektion (intern)",
//       colorcode: "#00887a",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
//     },
//     creationdate: 1673990400000,
//     repetition: "24m",
//     reminder: "1m",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory77",
//     title: "Titel der Vorlage 6",
//     category: {
//       name: "Routinewartung (intern)",
//       colorcode: "#d81a60",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
//     },
//     creationdate: 1674076800000,
//     repetition: "1y",
//     reminder: "1w",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory88",
//     title: "Titel der Vorlage 7",
//     category: {
//       name: "Herstellerwartung",
//       colorcode: "#3a48ab",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory4",
//     },
//     creationdate: 1674163200000,
//     repetition: "1w",
//     reminder: "2w",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory99",
//     title: "Titel der Vorlage 8",
//     category: {
//       name: "Pflichtinspektion",
//       colorcode: "#728217",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory1",
//     },
//     creationdate: 1674249600000,
//     repetition: "1w",
//     reminder: "1m",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory00",
//     title: "Titel der Vorlage 9",
//     category: {
//       name: "Inspektion (intern)",
//       colorcode: "#00887a",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
//     },
//     creationdate: 1674336000000,
//     repetition: "1m",
//     reminder: "1w",
//   },
//   {
//     nodeid: "247fn://247uptime.io/abc-maintenancecategory3",
//     title: "Titel der Vorlage 10",
//     category: {
//       name: "Routinewartung (intern)",
//       colorcode: "#d81a60",
//       nodeid: "247fn://247uptime.io/abc-maintenancecategory2",
//     },
//     creationdate: 1674422400000,
//     repetition: "1w",
//     reminder: "1w",
//   },
// ];

/* Maintenance Task Repetitions & Reminders */

const repetions = [
  { key: "onetime", value: "", label: i18n.maintenance_repetition_onetime },
  { key: "1w", value: "1", label: i18n.maintenance_repetition_oneweek },
  { key: "2w", value: "2", label: i18n.maintenance_repetition_twoweek },
  { key: "1m", value: "1", label: i18n.maintenance_repetition_month },
  { key: "2m", value: "2", label: i18n.maintenance_repetition_months },
  { key: "3m", value: "3", label: i18n.maintenance_repetition_months },
  { key: "6m", value: "6", label: i18n.maintenance_repetition_months },
  { key: "12m", value: "12", label: i18n.maintenance_repetition_months },
  { key: "18m", value: "18", label: i18n.maintenance_repetition_months },
  { key: "24m", value: "24", label: i18n.maintenance_repetition_months },
  { key: "36m", value: "36", label: i18n.maintenance_repetition_months },
  { key: "48m", value: "48", label: i18n.maintenance_repetition_months },
];

function GetRepetitionValue(key) {
  let repetitionString = "";
  repetions.map((repetion) => {
    if (repetion.key === String(key)) {
      repetitionString = repetion.value + " " + repetion.label;
    }
  });
  return repetitionString;
}

const reminders = [
  { key: "2d", value: "2", label: i18n.maintenance_reminder_Days },
  { key: "1w", value: "1", label: i18n.maintenance_reminder_Week },
  { key: "2w", value: "2", label: i18n.maintenance_reminder_Weeks },
  { key: "1m", value: "1", label: i18n.maintenance_reminder_month },
];

const getReminderItems = (repitionValue) => {
  let reminderItems;

  switch (repitionValue) {
    case "1w":
      reminderItems = [
        { key: "2d", value: "2", label: i18n.maintenance_reminder_Days },
      ];
      break;
    case "2w":
      reminderItems = [
        { key: "2d", value: "2", label: i18n.maintenance_reminder_Days },
        { key: "1w", value: "1", label: i18n.maintenance_reminder_Week },
      ];
      break;
    case "1m":
      reminderItems = [
        { key: "2d", value: "2", label: i18n.maintenance_reminder_Days },
        { key: "1w", value: "1", label: i18n.maintenance_reminder_Week },
        { key: "2w", value: "2", label: i18n.maintenance_reminder_Weeks },
      ];
      break;
    default:
      reminderItems = reminders;
  }

  return reminderItems;
};

const getIntervalsInMs = (repitition) => {
  if (repitition === "1w") return 7 * 24 * 60 * 60 * 1000;
  else if (repitition === "2w") return 14 * 24 * 60 * 60 * 1000;
  else if (repitition === "1m")
    return moment()
      .add(1, "months")
      .diff(moment());
  else if (repitition === "2m")
    return moment()
      .add(2, "months")
      .diff(moment());
  else if (repitition === "3m")
    return moment()
      .add(3, "months")
      .diff(moment());
  else if (repitition === "6m")
    return moment()
      .add(6, "months")
      .diff(moment());
      else if (repitition === "1y")
      return moment()
        .add(12, "months")
        .diff(moment());
  else if (repitition === "12m")
    return moment()
      .add(12, "months")
      .diff(moment());
  else if (repitition === "18m")
    return moment()
      .add(18, "months")
      .diff(moment());
  else if (repitition === "24m")
    return moment()
      .add(24, "months")
      .diff(moment());
  else if (repitition === "36m")
    return moment()
      .add(36, "months")
      .diff(moment());
  else if (repitition === "48m")
    return moment()
      .add(48, "months")
      .diff(moment());
  /* return {
    twoDays: 2 * 24 * 60 * 60 * 1000,
    oneWeek: 7 * 24 * 60 * 60 * 1000,
    twoWeeks: 14 * 24 * 60 * 60 * 1000,
    oneMonth: moment().add(1, 'months').diff(moment()),
  }; */
};

function GetReminderValue(key) {
  let reminderString = "";
  reminders.map((reminder) => {
    if (reminder.key === String(key)) {
      reminderString = reminder.value + " " + reminder.label;
    }
  });
  return reminderString;
}

export {
  getNotificationTooltipAndColor,
  NotificationTypeUpdated,
  getNotificationTypee,
  GetNotificationTypeCode,
  GetReminderValue,
  GetRepetitionValue,
  NotificationType,
  StatusType,
  notificationTypes,
  reminders,
  repetions,
  getReminderItems,
  getIntervalsInMs,
  // maintenance_templates
};
